// extracted by mini-css-extract-plugin
export var rgpdContainer = "rgpd-module--rgpd-container--75984";
export var rgpdSubTitle = "rgpd-module--rgpd-sub-title--26aeb";
export var rgpdTitle = "rgpd-module--rgpd-title--e1b84";